import React, { useState, useEffect } from "react";
import HomeFooter from "../Home/Home/HomeFooter/HomeFooter";
import HomeFact from "../Home/Home/HomeFact/HomeFact";
import HomeHeader from "../Home/Home/HomeHeader/HomeHeader";
import AboutAppoinment from "./AboutAppoinment/AboutAppoinment";
import AboutArea from "./AboutArea/AboutArea";
import HomeThreeFaq from "../HomeThree/HomeThreeFaq/HomeThreeFaq";
import { buscarServico } from "../../hooks/getService";

const DiabetesGestacional = () => {
  const [servicoData, setServicoData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const idArea = 2;
  const idServico = 11;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data = await buscarServico(idServico);
        if (data) {
          setServicoData(data);
        } else {
          console.error("Erro ao buscar dados do serviço.");
        }
      } catch (error) {
        console.error("Erro na requisição:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [idServico]);

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(valor);
  };

  const title = servicoData?.Nome || "Diabetes Gestacional";
  const descricao =
    "Mulher Olis, não deixe que o diagnóstico do diabetes gestacional a intimide. Junte-se a nós e ganhe confiança para enfrentar essa fase da sua jornada materna com conhecimento e apoio. Estamos aqui para ajudá-la a cada passo do caminho.";

  const precoAVista = servicoData?.Preco ? Number(servicoData.Preco) : 0;
  const parcela6x = servicoData?.Parcelas?.find(
    (p) => p.QuantidadeParcelas === 6
  )?.ValorParcela;
  const valorParcela6x = parcela6x ? Number(parcela6x) / 6 : 0;
  const price = servicoData
    ? `${formatarMoeda(precoAVista)} ou até 6x de ${formatarMoeda(
        valorParcela6x
      )}`
    : "Carregando preço...";

  const fatos = {
    titulo_fatos: "Empodere-se com Conhecimento",
    descricao_fatos:
      "Você sabia que a diabetes na gestação acomete cerca de 18% das mulheres no Brasil? É uma condição que pode trazer complicações para sua saúde e também do seu bebê. Como consequência, temos o ganho de peso exagerado, hipoglicemias após o nascimento e até predisposição à obesidade e diabetes no futuro.",
    subtitulos: [
      {
        titulo: "Acompanhamento personalizado",
        subtitulo:
          "Nos adaptamos às suas necessidades individuais, levando em consideração fatores como idade gestacional, peso, níveis de atividade física e preferências alimentares para adequarmos o melhor tratamento para sua realidade.",
      },
      {
        titulo: "Facilidade de acesso",
        subtitulo:
          "Experimente a conveniência de ter acesso a orientações e suporte online, que podem ser acessados a qualquer momento e de qualquer lugar, sem a necessidade de deslocamento para consultas presenciais.",
      },
    ],
  };

  const passos = [
    {
      titulo: "Agendamento do serviço",
      descricao: "Escolha o melhor horário para você",
    },
    {
      titulo: "Envio de exames prévios via WhatsApp, se houver",
      descricao: "Receba o link de atendimento",
    },
    {
      titulo: "Recebimento do Link de Atendimento, via Whatsapp via WhatsApp",
      descricao: "Receba o link de atendimento",
    },
    {
      titulo: "Consulta realizada por videochamada (45 min)",
      descricao: "Aguarde o retorno",
    },
    {
      titulo: "Solicitação de exames, se necessário",
      descricao: "Realize os exames",
    },
    {
      titulo: "Envio de relatório Médico",
      descricao: "Receba o relatório médico",
    },
  ];

  const imgUrl = "img/services/PreNatal.PNG";

  if (isLoading) {
    return (
      <>
        <HomeHeader />
        <div style={{ textAlign: "center", padding: "50px" }}>
          <h2>Carregando...</h2>
        </div>
        <HomeFooter />
      </>
    );
  }

  return (
    <>
      <HomeHeader />
      <AboutArea
        title={title}
        descricao={descricao}
        price={price}
        idArea={idArea}
        idServico={idServico}
        imgUrl={imgUrl}
      />
      <HomeFact fatos={fatos} />
      <AboutAppoinment passos={passos} />
      <HomeThreeFaq />
      <HomeFooter />
    </>
  );
};

export default DiabetesGestacional;
